import {useQuery, UseQueryResult} from "@tanstack/react-query";
import {CustomAxiosError, useApiCalls} from "../../../../../../../logics/api_config";
import {useAuth} from "../../../../../../../utils/contexts/auth-context";
import {
    ISpecialMonthEnds
} from "../../../../../../../utils/interfaces/my_documents/fiscal_registry/payment/ISpecialMonthEnds";


const useApiGetSpecialMonthEndss = (): UseQueryResult<ISpecialMonthEnds[], CustomAxiosError> => {
    const {selectedCompany} = useAuth();

    const {get} = useApiCalls()

    async function doGet(company_token: string | undefined): Promise<ISpecialMonthEnds[]> {
        try {
            const response = await get(`/api/company/${company_token}/my_documents/payment/special_month_ends`);
            return response?.data;
        } catch (error) {
            throw error;
        }
    }

    return useQuery({
        queryKey: ["useApiGetSpecialMonthEndss"],
        queryFn: () => doGet(selectedCompany?.company_token,),
    })
};

export default useApiGetSpecialMonthEndss